import axios from 'axios';

const baseURL = process.env.REACT_APP_DOMAIN || 'http://localhost:5030';
const instance = axios.create({ baseURL });

// Add a request interceptor
instance.interceptors.request.use(
  (config) => {
    // Do something before request is sent

    if (!config?.headers || !config?.headers['Content-Type']) {
      config.headers.Accept = 'application/json';
      config.headers['Content-Type'] = 'application/json';
    }

    if (config?.url.indexOf('http') >= 0) {
      config.baseURL = null;
    }

    return config;
  },
  // Do something with request error
  (error) => Promise.reject(error),
);

// Add a response interceptor
instance.interceptors.response.use(
  // Any status code that lie within the range of 2xx cause this function to trigger
  // Do something with response data
  (response) => response,
  // Any status codes that falls outside the range of 2xx cause this function to trigger
  // Do something with response error
  (error) => Promise.reject(error),
);

export default instance;
